import { primary_color } from '../../../Helper/uiHelper'

const RenewalEmailGenerateStep = () => {
  return (
    <div>
      <div className='body1 mb-2 font-weight-bold' style={{ color: primary_color }}>
        Renewal email are generated based on
      </div>
      <ul style={{ color: '#8E8E8E' }} className='ml-3'>
        <li className='subtitle1'>Setting tabs in schools .</li>
        <li className='subtitle1'>The customer choose to have a renewal email.</li>
        <li className='subtitle1'>The customer chose to receive communication from locker rental.</li>
        <li className='subtitle1'>The students who are not in their final year at that school.</li>
      </ul>
    </div>
  )
}

export default RenewalEmailGenerateStep
